'use client';

import React, { FC, useEffect, useState } from 'react';
import arrow from './assets/arrow.svg';
import Image from 'next/image';
import { Link } from '@/navigation';
import classNames from 'classnames';
import useFeature from '@/hooks/useFeature';

// % of window scrolled before showing up arrow
const SCROLL_RATIO = 0.6;

const BackToTop: FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [href, setHref] = useState('#top');

  useEffect(() => {
    const onScroll = () => {
      const ratio = window.scrollY / window.outerHeight;
      if (ratio > SCROLL_RATIO && !isVisible) {
        setIsVisible(true);
      } else if (ratio < SCROLL_RATIO && isVisible) {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', onScroll);

    return () => window.removeEventListener('scroll', onScroll);
  }, [isVisible]);

  useEffect(() => {
    // Remove trailing slash from the current URL if it exists
    const currentUrl = window.location.href;
    const canonicalUrl = currentUrl.endsWith('/')
      ? currentUrl.slice(0, -1)
      : currentUrl;
    setHref(canonicalUrl + '#top');
  }, []);

  const isAdaEnabled = useFeature('retention-enable-ada');

  return (
    <Link
      href={href}
      className={classNames(
        'fixed p-2 transition-all',
        isVisible ? 'opacity-full' : 'opacity-0',
        {
          ['bottom-[80px] hover:bottom-[84px] right-[48px]']: isAdaEnabled,
          ['bottom-[110px] hover:bottom-[114px] right-[38px]']: !isAdaEnabled,
        },
      )}
      aria-label="Scroll to top"
    >
      <Image
        src={arrow}
        alt="Up arrow"
        className="w-[22px] -rotate-90 transform"
      />
    </Link>
  );
};

export default React.memo(BackToTop);
